import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Menu extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <rect x="1" y="7" width="14" height="2" />
          <rect x="1" y="1" width="14" height="2" />
          <rect x="1" y="13" width="14" height="2" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Menu.js